import { searchOrganisations, SearchOrganisationsOrganisationType } from "../../../../../service/query";
import { Status } from "../../../../../service/Shared";
import { Toast } from "../../../../../widget";

// The organisation details query does not return the flag, so searchOrganisations is the only read.
// Undefined means "not known" - the card stays hidden rather than showing a guessed value.
export const getAccessInviteOptOut = async (
  organisationUuid: string,
  organisationType: SearchOrganisationsOrganisationType
): Promise<boolean | undefined> => {
  try {
    const response = await searchOrganisations({
      organisationType,
      excludedProjectUuid: null,
      paging: { limit: 1, beforeCursor: "", afterCursor: "" },
      filter: { results: { organisationUuid: { operator: "eq", value: organisationUuid } } },
    });

    if (response.status !== Status.Success || !response.data?.results.length) {
      Toast.error({ message: "Couldn't load your project access invitation setting." });
      return undefined;
    }

    return response.data.results[0].accessInviteOptOut;
  } catch {
    Toast.error({ message: "Couldn't load your project access invitation setting." });
    return undefined;
  }
};
